import { emptyNull } from '../../../shared/misc';

export default function applyDefaults(config = emptyNull) {
  return {
    urlBase: config.urlBase ?? 'https://stats.virtual-meeting.net/',
    trackerUrl: config.trackerUrl ?? 'https://stats.virtual-meeting.net/matomo.php',
    siteId: config.siteId ?? 42,
    configurations: {
      ...config.configurations,
      disableCookies: config.configurations?.disableCookies ?? true
    }
  };
}
